export class CMDApiFields{
    public static  storerTypeValue:string = '1';
    public static  customerCodeCMDField:string = 'cMDCustomerCode';
    public static  concernCodeCMDField:string = 'cMDConcernCode';
    public static  tradingNameCMDField:string = 'cMDTradingName';
    public static  storerTypeField:string = 'storerType';
    public static  concernCodeField:string = 'concernCode';
    public static  archTypeField:string = 'archeType';
    public static  storertableId:string = 'storersearchtd';
      // error codes for UI validation of customer code and archeType fields.
    public static customerCodeFlag = 1;
    public static archTypeFlag = 2;
}
export class TransferPopulateFields {
    public static readonly ASNFizUpdLotToSerialNo = 'ASNFizUpdLotToSerialNo';
    public static readonly storerKey = 'fromStorerKey';
    public static readonly facilityKey = 'fromFacility';
    public static readonly serialNoUpdateLotLocID = 'SerialNoUpdateLotLocID';
}

export const HAS_RIGHTS = {
  YES: 'Y',
  NO: 'N'
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/models/api-fields.ts